module.exports = __webpack_public_path__ + "static/media/img-boxfit-quote@2x.72b9e45c.png";